// extracted by mini-css-extract-plugin
export default {"reportToggle":"reportToggle_reportToggle__paft7"};